import type { ListTableBatchButtonsCallbacks } from "./list-table-batch-buttons.type";
import type { ListItem } from "@/modules/list";

export const isBatchModeActive = <Item extends ListItem = ListItem>({
  onBatchEditClick,
  onBatchDeleteClick,
  onBatchDissociateClick,
}: ListTableBatchButtonsCallbacks<Item>): boolean => {
  return !!(onBatchEditClick || onBatchDeleteClick || onBatchDissociateClick);
};
